export function nowIso() {
    return new Date().toISOString();
}
export function today() {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    return date;
}
export function todayKey() {
    return toDateKey(today());
}
export function toDateKey(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}
export function daysBetween(fromKey, toKey) {
    const from = new Date(`${fromKey}T00:00:00`);
    const to = new Date(`${toKey}T00:00:00`);
    return Math.round((to.getTime() - from.getTime()) / (1000 * 60 * 60 * 24));
}
export function isBeforeToday(dateKey) {
    return daysBetween(todayKey(), dateKey) < 0;
}
export function addDays(dateKey, amount) {
    const date = new Date(`${dateKey}T00:00:00`);
    date.setDate(date.getDate() + amount);
    return toDateKey(date);
}
export function formatMonthLabel(year, month) {
    return new Date(year, month, 1).toLocaleDateString("en-US", {
        month: "long",
        year: "numeric",
    });
}
